import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DOMPurify from 'dompurify';
import api from '../services/api';

const S = { h2: { fontSize: '1.05rem', fontWeight: 700, marginTop: 32, marginBottom: 6 } };

export default function Datenschutz() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getPublicLayout('datenschutz')
      .then(d => {
        if (d && !d.fallback && d.layout?.layout_json?.fields?.content) {
          setContent(d.layout.layout_json.fields.content);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '60px 24px', fontFamily: "'Inter', sans-serif", color: 'var(--text-dark)', lineHeight: 1.75 }}>
      <Link to="/" style={{ color: 'var(--accent-saffron)', textDecoration: 'none', fontSize: '.88rem' }}>← Zurück zur Startseite</Link>
      <h1 style={{ fontFamily: "'Playfair Display', serif", marginTop: 32, marginBottom: 8 }}>Datenschutzerklärung</h1>
      <p style={{ color: 'var(--text-mid)', fontSize: '.85rem', marginBottom: 40 }}>Stand: {new Date().toLocaleDateString('de-AT', { month: 'long', year: 'numeric' })}</p>

      {loading ? (
        <div style={{ color: 'var(--text-mid)', fontSize: '.88rem' }}>Lade…</div>
      ) : content ? (
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }} />
      ) : (
        <>
          <h2 style={S.h2}>1. Verantwortlicher</h2>
          <p style={{ color: 'var(--text-mid)' }}>
            [Name]<br />[Adresse]<br />[E-Mail]
          </p>
          <h2 style={S.h2}>2. Welche Daten wir speichern</h2>
          <ul style={{ color: 'var(--text-mid)', paddingLeft: 20 }}>
            <li><strong>Benutzerkonto:</strong> Benutzername, Passwort (verschlüsselt)</li>
            <li><strong>Rezeptdaten:</strong> Hochgeladene Bilder und daraus extrahierte Texte</li>
            <li><strong>Nutzungsdaten:</strong> Anzahl der Scans (für Quota-Verwaltung)</li>
            <li><strong>Kühlschrank-Scan (anonym):</strong> Erkannte Lebensmittel und deren geschätzte Haltbarkeit werden ohne Personenbezug gespeichert, um die Qualität der Haltbarkeitsschätzungen kontinuierlich zu verbessern. Es werden keine Bilder und keine Benutzerzuordnungen gespeichert.</li>
          </ul>
          <h2 style={S.h2}>3. Einsatz von KI-Diensten (Google Gemini API)</h2>
          <p style={{ color: 'var(--text-mid)' }}>
            Zur Texterkennung in Bildern nutzen wir die <strong>Google Gemini API</strong> (Google LLC, USA).
            Hochgeladene Bilder werden zur Verarbeitung temporär an Google übermittelt. Google verarbeitet
            diese Daten auf Grundlage von Standardvertragsklauseln (Art. 46 DSGVO).
            Weitere Informationen: <a href="https://policies.google.com/privacy" style={{ color: 'var(--accent-saffron)' }} target="_blank" rel="noreferrer">policies.google.com/privacy</a>
          </p>
          <h2 style={S.h2}>4. Speicherdauer</h2>
          <p style={{ color: 'var(--text-mid)' }}>
            Deine Daten werden gespeichert solange dein Konto besteht. Du kannst jederzeit die
            Löschung deines Kontos und aller zugehörigen Daten verlangen.
          </p>
          <h2 style={S.h2}>5. Deine Rechte (DSGVO Art. 15–22)</h2>
          <ul style={{ color: 'var(--text-mid)', paddingLeft: 20 }}>
            <li>Recht auf Auskunft über gespeicherte Daten</li>
            <li>Recht auf Berichtigung oder Löschung</li>
            <li>Recht auf Einschränkung der Verarbeitung</li>
            <li>Recht auf Datenübertragbarkeit</li>
            <li>Beschwerderecht bei der österreichischen Datenschutzbehörde (dsb.gv.at)</li>
          </ul>
          <h2 style={S.h2}>6. Kontakt</h2>
          <p style={{ color: 'var(--text-mid)' }}>
            Bei Fragen zum Datenschutz: <a href="mailto:[kontakt@domain.at]" style={{ color: 'var(--accent-saffron)' }}>[kontakt@domain.at]</a>
          </p>
          <div style={{ padding: '16px 20px', background: 'color-mix(in srgb, var(--accent-saffron) 12%, var(--surface))', borderRadius: 8, fontSize: '.85rem', color: 'var(--accent-saffron)', border: '1px solid color-mix(in srgb, var(--accent-saffron) 40%, transparent)', marginTop: 32 }}>
            ⚠️ Platzhalter — bitte im Admin unter Seiten → Datenschutz → Inhalt bearbeiten.
          </div>
        </>
      )}
    </div>
  );
}
